export default "__VITE_ASSET__CtNz9WMQ__"